import { render, staticRenderFns } from "./DetailsCourses.vue?vue&type=template&id=811fd268&scoped=true&"
import script from "./DetailsCourses.vue?vue&type=script&lang=js&"
export * from "./DetailsCourses.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCourses.vue?vue&type=style&index=0&id=811fd268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811fd268",
  null
  
)

export default component.exports